import { useUnit } from "effector-react"
import { Button, Popup, Typography } from "@callcenter/design-system"
import { t } from "i18next"
import { $whiteLabel } from "@callcenter/white-label"

import { feedbackModel } from "../../models"
import { feedbackApi } from "../../api"
import { FeedbackForm } from "./feedback-form"

import styles from "./feedback-modal.module.pcss"

export const FeedbackModal = () => {
  const isOpen = useUnit(feedbackModel.$isFeedbackModalOpen)
  const isSubmitting = useUnit(feedbackApi.submitFeedbackFx.pending)
  const formErrors = useUnit(feedbackModel.$formErrors)
  const { brandName } = useUnit($whiteLabel.$whiteLabelSettings)

  const actions = useUnit({
    feedbackModalClosed: feedbackModel.feedbackModalClosed,
    handleSubmit: feedbackModel.handleSubmit
  })

  if (!isOpen) {
    return null
  }

  return (
    <Popup title={t("component_commonKeys_feedbackModal_title")} onClose={actions.feedbackModalClosed}>
      <div className={styles.content}>
        <Typography.Body2 className={styles.description}>
          {t("component_commonKeys_feedbackModal_description", { x: brandName })}
        </Typography.Body2>

        <FeedbackForm />

        <div className={styles.buttonsContainer}>
          {formErrors.reasons && <Typography.Small className={styles.errorText}>{formErrors.reasons}</Typography.Small>}
          <div className={styles.buttonsGroup}>
            <Button kind="outline" onClick={actions.feedbackModalClosed} isDisabled={isSubmitting}>
              {t("component_commonKeys_cancelButton_cancelButton")}
            </Button>
            <Button onClick={actions.handleSubmit} isDisabled={isSubmitting}>
              {t("component_commonKeys_sendButton_sendButton")}
            </Button>
          </div>
        </div>
      </div>
    </Popup>
  )
}
